import React from 'react'
import Explore_category from './explore-category/Explore_category'
import Upcoming_events from './upcoming-events/Upcoming_events'
import Explore_top_products from './explore-top-products/Explore_top_products'
import Chants from '../home/chants/Chants'
import Register_now from './register-now/Register_now'
import Your_spritual from './your-spritual/Your_spritual'
import Show_your_support from './show-your-support/Show_your_support'

const Explore = () => {
    return (
        <>
            <Explore_category />
            <Upcoming_events />
            <Explore_top_products />
            <Chants />
            <Register_now />
            <Your_spritual />
            <Show_your_support />
        </>
    )
}

export default Explore